export default __webpack_public_path__ + "static/media/youtubeWhiteIcon.bd5b5cf7.svg";